export async function createSubscription(priceId: string) {
  try {
    const response = await fetch(process.env.REACT_APP_API_HOST + "billing/create-subscription", {
      method: "POST",
      headers: {
        accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("tokenLida"),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ price_id: priceId }),
    })

    if (!response.ok) {
      throw new Error("Failed to create subscription")
    }

    return await response.json()
  } catch (error) {
    console.error("Error creating subscription:", error)
    throw error
  }
}

